export const cardContentArr = [
    [
        "Well prepared",
        "Fact oriented",
        "Proud of product and expertise",
        "In control of his/her emotions",
    ],
    [
        "Well prepared",
        "Relationship oriented",
        "Knows to adapt",
        "Talks powerful, yet chooses words carefully",
    ],
    [
        "No detailed preparation",
        "Relationship oriented",
        "Good listener",
        "Takes a moment to think before speaking",
    ],
    [
        "No detailed preparation",
        "Fact oriented",
        "Rather impulsive",
        "Talks spontaneously without much thought",
    ],
];

export const monthOptions = [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 }
];
